function Divider() {
  return (
    <svg
      width="335"
      height="1"
      viewBox="0 0 335 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="-3" width="342" height="1" rx="0.5" fill="#E6E8EC" />
    </svg>
  );
}

export default Divider;